<div class="not-found-page min-h-screen flex flex-col items-center justify-center px-6 py-16">

  <div class="not-found-content relative z-10 w-full max-w-lg text-center">

    <!-- Label -->
    <p class="text-xs font-bold tracking-[0.22em] uppercase text-[var(--color-muted-foreground)] mb-8">
      Error 404
    </p>

    <!-- 4 · compass · 4 -->
    <div class="not-found-hero mb-8">
      <span class="nf-digit">4</span>

      <div class="nf-compass mx-1">
        <div class="compass-ring"></div>
        <div class="compass-ring-inner"></div>
        <span class="compass-label n">N</span>
        <span class="compass-label s">S</span>
        <span class="compass-label e">E</span>
        <span class="compass-label w">W</span>
        <div class="compass-needle">
          <div class="needle-north"></div>
          <div class="needle-south"></div>
        </div>
        <div class="compass-dot"></div>
      </div>

      <span class="nf-digit">4</span>
    </div>

    <!-- Card -->
    <div class="nf-card mb-8">

      <!-- Path strip -->
      <div class="nf-path-strip mb-5">
        <div class="nf-path-dot"></div>
        <div class="nf-path-dot"></div>
        <div class="nf-path-x">
          <svg class="w-3 h-3 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
          </svg>
        </div>
        <div class="nf-path-dot"></div>
        <div class="nf-path-dot"></div>
        <span class="text-xs font-semibold text-[var(--color-primary)] ml-1">Path not found</span>
      </div>

      <h1 class="text-xl font-bold text-[var(--color-foreground)] mb-2">
        You've gone off the map
      </h1>
      <p class="text-sm text-[var(--color-muted-foreground)] leading-relaxed mb-6">
        This page doesn't exist on Chipo. Check the link, or head back to your dashboard and keep learning.
      </p>

      <div class="flex flex-wrap items-center justify-center gap-3">
        <button type="button" (click)="goHome()" class="nf-btn-primary">
          <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 22V12h6v10"/>
          </svg>
          Back to Dashboard
        </button>
        <button type="button" (click)="goBack()" class="nf-btn-secondary">
          <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"/>
          </svg>
          Go Back
        </button>
      </div>

    </div>

    <!-- Footer note -->
    <p class="text-xs text-[var(--color-muted-foreground)]">
      Still lost? Contact your school administrator.
    </p>

  </div>

</div>